import { render, staticRenderFns } from "./TheHeaderDropdownPartners.vue?vue&type=template&id=534d660e&scoped=true"
import script from "./TheHeaderDropdownPartners.vue?vue&type=script&lang=js"
export * from "./TheHeaderDropdownPartners.vue?vue&type=script&lang=js"
import style0 from "./TheHeaderDropdownPartners.vue?vue&type=style&index=0&id=534d660e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534d660e",
  null
  
)

export default component.exports